import { useState, useMemo } from 'react'

import { FilterOption } from '../types'

interface UseZipcodeFilterProps {
  selectedZipcodes: string[]
  onZipcodeChange: (zipcodes: string[]) => void
}

export const useZipcodeFilter = ({
  selectedZipcodes,
  onZipcodeChange,
}: UseZipcodeFilterProps) => {
  // Ensure selectedZipcodes is always an array
  const safeSelectedZipcodes = useMemo(
    () => (Array.isArray(selectedZipcodes) ? selectedZipcodes : []),
    [selectedZipcodes]
  )
  const [newZipcode, setNewZipcode] = useState('')
  const [suggestedZipcodes, setSuggestedZipcodes] = useState<string[]>([])

  const handleAddZipcode = (zipcode: string) => {
    if (zipcode && !safeSelectedZipcodes.includes(zipcode)) {
      onZipcodeChange([...safeSelectedZipcodes, zipcode])
    }
    setNewZipcode('')
  }

  const handleRemoveZipcode = (zipcode: string) => {
    onZipcodeChange(safeSelectedZipcodes.filter((z) => z !== zipcode))
  }

  const handleAddSuggestedZipcode = (zipcode: string) => {
    if (zipcode && !safeSelectedZipcodes.includes(zipcode)) {
      onZipcodeChange([...safeSelectedZipcodes, zipcode])
      // Remove from suggested list
      setSuggestedZipcodes(suggestedZipcodes.filter((z) => z !== zipcode))
    }
  }

  const handleAddAllSuggestedZipcodes = () => {
    const newZipcodes = suggestedZipcodes.filter(
      (zip) => !safeSelectedZipcodes.includes(zip)
    )
    if (newZipcodes.length > 0) {
      onZipcodeChange([...safeSelectedZipcodes, ...newZipcodes])
      setSuggestedZipcodes([])
    }
  }

  const options: FilterOption[] = useMemo(() => {
    return safeSelectedZipcodes.map((zipcode) => ({
      label: zipcode,
      value: zipcode,
      selected: true,
    }))
  }, [safeSelectedZipcodes])

  return {
    selected: safeSelectedZipcodes,
    options,
    newZipcode,
    setNewZipcode,
    handleAddZipcode,
    handleRemoveZipcode,
    suggestedZipcodes,
    setSuggestedZipcodes,
    handleAddSuggestedZipcode,
    handleAddAllSuggestedZipcodes,
    onChange: onZipcodeChange,
    isLoaded: true,
  }
}
